import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { BaseStore } from './BaseStore';
var ThemeStore = /*#__PURE__*/function (_BaseStore) {
  _inherits(ThemeStore, _BaseStore);
  var _super = _createSuper(ThemeStore);
  function ThemeStore() {
    var _this;
    _classCallCheck(this, ThemeStore);
    _this = _super.call(this);
    _this.setState({
      themes: new Map(),
      themeComponents: new Map(),
      partials: []
    });
    return _this;
  }
  _createClass(ThemeStore, [{
    key: "registerTheme",
    value: function registerTheme(themeData) {
      var themes = this.state.themes;
      themes.set(themeData.name, themeData);
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        themes: new Map(themes)
      }));
    }
  }, {
    key: "registerThemeComponents",
    value: function registerThemeComponents(id, component) {
      var themeComponents = this.state.themeComponents;
      themeComponents.set(id, component);
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        themeComponents: new Map(themeComponents)
      }));
    }
  }, {
    key: "setScope",
    value: function setScope(scope) {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        scope: scope
      }));
    }
  }, {
    key: "enabledThemes",
    get: function get() {
      return this.state.enabledThemes || _toConsumableArray(this.state.themes.keys());
    }
  }, {
    key: "updateState",
    value: function updateState(data) {
      this.setState(_objectSpread(_objectSpread({}, this.state), data));
    }
  }, {
    key: "addCustomStyles",
    value: function addCustomStyles() {
      var customStyles = this.state.customStyles || [];
      for (var _len = arguments.length, css = new Array(_len), _key = 0; _key < _len; _key++) {
        css[_key] = arguments[_key];
      }
      css.forEach(function (c) {
        if (customStyles.indexOf(c) < 0) {
          customStyles.push(c);
        }
      });
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        customStyles: customStyles
      }));
    }
  }]);
  return ThemeStore;
}(BaseStore);
export { ThemeStore };